import { GoogleAuthProvider, signInWithPopup, signOut, onAuthStateChanged } from 'firebase/auth';
import { auth } from './internal/FirebaseConfig';

const provider = new GoogleAuthProvider();

const createAuthService = () => {
	let isSigningIn = false;
	let { promise: initializing, resolve: resolveInit } = Promise.withResolvers();


	// Sign in with redirect
	const signIn = async () => {
		await initializing
		if (isSigningIn) {
			return
		}

		if (auth.currentUser == null) {
			isSigningIn = true

			try {
				console.log("SIGN IN")
				const result = await signInWithPopup(auth, provider);
				return result;
			} catch (error) {
				console.error(error);
			} finally {
				isSigningIn = false; // Always reset
			}
		}
	}

	const signOutUser = () => {
		console.log("SIGN OUT")
		signOut(auth)
	}

	const subscribeToAuth = callback => {
		const unsubscribe = onAuthStateChanged(auth, user => {
			resolveInit()
			callback(user)
		})
		return unsubscribe
	}

	return Object.freeze({
		signIn,
		signOutUser,
		subscribeToAuth
	});
}

export const authService = createAuthService();
